import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ExplanationRow } from './components/ExplanationRow';
import Summary from './SummaryData';
import Basic from './Basic';
import CompanyRatings from './CompanyRatings';
import NegativeData from './NegativeData';
import FinancialData from './FinancialData';

const { Title } = Typography;

const Report = ({ handleBuyReport }) => {
  const { t } = useTranslation();
  const { report } = useSelector(state => state.companySearchResult);

  if (report)
    return (
      <>
        <Title level={5} className="header">
          01. {t('professionalReport.tab.summary')}
        </Title>
        <Summary report={report} handleBuyReport={handleBuyReport} />
        <Title level={5} className="header space-top-md">
          02. {t('professionalReport.tab.basicData')}
        </Title>
        <Basic handleBuyReport={handleBuyReport} />
        <Title level={5} className="header space-top-md">
          03. {t('professionalReport.tab.companyRatings')}
        </Title>
        <CompanyRatings handleBuyReport={handleBuyReport} />
        <Title level={5} className="header space-top-md">
          04. {t('professionalReport.tab.negativeData')}
        </Title>
        <NegativeData handleBuyReport={handleBuyReport} />
        <Title level={5} className="header space-top-md">
          05. {t('professionalReport.tab.financialData')}
        </Title>
        <FinancialData handleBuyReport={handleBuyReport} />
        <ExplanationRow handleBuyReport={handleBuyReport} />
      </>
    );
  return (
    <Row gutter={[16, 16]}>
      <Col span={24} className="company-title">
        <Title level={2}>{t('companyResult.report.noReport')}</Title>
      </Col>
    </Row>
  );
};

export default Report;
